import React from 'react';
interface RadioListTwoColumnProps {
  options: (string | number)[];
  value: string | number;
  onChange: (value: any) => void;
  name: string;
}
export function RadioListTwoColumn({
  options,
  value,
  onChange,
  name
}: RadioListTwoColumnProps) {
  return <div className="grid grid-cols-2 gap-2" data-id="element-231">
      {options.map(option => {
      const isSelected = value === option;
      return <label key={option} className={`
              relative flex items-center px-4 py-3 rounded-lg border cursor-pointer transition-all
              ${isSelected ? 'border-violet-600 bg-violet-50 ring-1 ring-violet-600' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}
            `} data-id="element-232">
            <input type="radio" name={name} value={option} checked={isSelected} onChange={() => onChange(option)} className="sr-only" data-id="element-233" />
            <div className={`w-4 h-4 rounded-full border flex items-center justify-center mr-3 ${isSelected ? 'border-violet-600' : 'border-gray-300'}`} data-id="element-234">
              {isSelected && <div className="w-2 h-2 rounded-full bg-violet-600" data-id="element-235" />}
            </div>
            <span className={`text-sm font-medium ${isSelected ? 'text-violet-900' : 'text-gray-700'}`} data-id="element-236">
              {option}
            </span>
          </label>;
    })}
    </div>;
}